/**
 * @file   download-app.js 处理app下载相关的一些工具方法
 * @author zhaocaimao-fe<zhaocaimao-fe@baidu.com>
 * @date   2021-01-04
 */
import {isIOS} from '@baidu/xbox/os';
import {guid} from '@baidu/exp-utils';

const NEW_CHANNEL_NUMBER = 'zhaocaimao';

/**
 * 打开app默认失败回调
 *
 * @param  {string=} newCN 新增渠道号
 * @return {Object} android/ios下载链接
 */
export function getDownloadLinks(newCN = NEW_CHANNEL_NUMBER) {
    return {
        appStore: 'https://apps.apple.com/cn/app/%E5%8F%A4%E7%89%A9%E6%BD%AE%E7%8E%A9/id1523487452',
        apk: `https://downpack.baidu.com/zhaocaimao_AndroidPhone_${newCN}.apk`
    };
}

/**
 * 微信/QQ内打开app的浮层提示
 */
export function showGuide() {
    const devElement = document.createElement('div');

    devElement.addEventListener('click', function () {
        devElement.remove();
    });
    devElement.innerHTML = `
        <style>
            .guide-wrap {
                position: fixed;
                top: 0;
                width: 100%;
                z-index: 999999;
                min-height: 100%;
                color: #fff;
                background: rgba(0, 0, 0, .7);
            }
            .guide-container {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }
            .guide-container .arrow-wrap {
                position: absolute;
                width: 75px;
                height: 75px;
                top: 14px;
                right: 20px;
                background: url(https://gemapp.cdn.bcebos.com/pic/bgpq2t5w0dd516dea4a88164) center / contain no-repeat;
            }
            .guide-wrap .tips-wrap {
                margin-top: 92px;
                margin-left: 108px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #fff;
                line-height: 30px;
            }
            .guide-wrap .safari-icon {
                width: 16px;
                height: 16px;
                margin-left: 5px;
                margin-right: 2px;
            }
        </style>
        <div class="guide-wrap" id="guide-wrap">
            <div class="guide-container">
                <div class="arrow-wrap"></div>
                <div class="tips-wrap">
                    <div>① 点击右上角的「···」</div>
                    <div>② 选择「在${isIOS() ? 'Safari<img class="safari-icon" src="https://gemapp.cdn.bcebos.com/pic/q73htep904dc5dde4804b383"/>' : '浏览器'}」中打开</div>
                </div>
            </div>
        </div>
    `;
    document.body.appendChild(devElement);
};

/**
 * 手百内通过端能力下载安卓apk 注册下载进度数据通道
*/
export function registerDownloadChannel(success, error = () => {}) {
    const stemp = guid();
    const callbacnName = 'callbacks' + stemp;
    window[callbacnName] = {};
    window[callbacnName].rdccallback = (action, res) => {
        const {status, message, data} = JSON.parse(res);
        if (status === 1) {
            error(message);
        }
        else {
            success(data);
            if (data.downStatus === 3) {
                unregisterDownloadChannel();
            }
        }
    };
    const register = 'baiduboxapp://v14/datachannel/register?'
        + 'action=com.baidu.channel.aladdin.downloadapk'
        + '&page=zhaocaimao'
        + '&jscallback=window["' + callbacnName + '"].rdccallback';
    window.location.href = register;
}

/**
 * 反注册数据通道
 * @important 注意不要重复注册，不然会重复回调，生命周期结束也应记得解除
*/
export function unregisterDownloadChannel() {
    const unregister = 'baiduboxapp://v14/datachannel/unregister?'
    + 'action=com.baidu.channel.aladdin.downloadapk'
    + '&page=zhaocaimao';
    window.location.href = unregister;
}

/**
 * 调起安装
*/
export function invokeDownload() {
    const stemp = guid();
    const callbacnName = 'callbacks' + stemp;
    window[callbacnName] = {};
    window[callbacnName].idcallback = () => {};
    const {uri, file_id} = window.APKdownloadInfo;
    const scheme = 'baiduboxapp://v14/download/app?params='
    + encodeURIComponent(JSON.stringify({
        'type': 'installapk',
        'business': 'zhaocaimao',
        'uri': uri,
        'packageName': file_id,
        'callback': 'window["' + callbacnName + '""].dlCallback'
    }));
    window.location.href = scheme;
}